
<template>
  <div class="warranty-container">
    <!-- 顶部搜索栏 -->
    <!-- <div class="header-bar">
      <i class="el-icon-arrow-left back-icon" @click="handleBack"></i>
      <el-input
        v-model="searchKeyword"
        placeholder="请输入搜索内容"
        class="search-input"
        clearable
        @keyup.enter.native="handleSearch"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div> -->

    <!-- 标签选择 -->
    <div class="tabs-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name=""></el-tab-pane>
        <el-tab-pane label="待保修" name="1"></el-tab-pane>
        <el-tab-pane label="已保修" name="2"></el-tab-pane>
        <el-tab-pane label="已过期" name="3"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="content-area">
      <!-- 表格 -->
      <el-card class="table-card">
        <el-table
          :data="warrantyList"
          style="width: 100%"
          v-loading="loading"
          empty-text="暂无数据"
          border
        >
          <el-table-column prop="applyCode" label="申请编码" min-width="180" align="center"></el-table-column>
          <el-table-column prop="shopName" label="店铺名称" min-width="180" align="center"></el-table-column>
          <el-table-column prop="maintenanceUserName" label="维保员" min-width="150" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="installConfirmTime" label="装机确认日期" min-width="180" align="center"></el-table-column>
          <el-table-column prop="completedWarrantyCount" label="已完成保修" min-width="130" align="center">
            <template slot-scope="scope">
              {{ scope.row.completedWarrantyCount || 0 }}次
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"                                       
                size="small"
                @click="handleViewHistory(scope.row)"
              >
                查看历史           
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container" v-if="warrantyList.length > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </el-card>
      <!-- 保修详情 -->
      <el-dialog 
        title="保修历史记录" 
        :visible.sync="warrantyDetailVisible" 
        width="60%" 
        :before-close="handleClose"
        class="history-dialog"
      >
        <el-table 
          :data="warrantyDetailList" 
          style="width: 100%"
          border
          :empty-text="warrantyDetailList.length === 0 ? '暂无历史记录' : ''"
        >
          <el-table-column prop="statusName" label="保修状态" min-width="180" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small">
                {{ scope.row.statusName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="保修时间" min-width="180" align="center"></el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { warrantyPage, warrantyDetail } from '@/api/warranty/warranty'
export default {
  name: 'Warranty',
  data() {
    return {
      // 搜索关键词
      // searchKeyword: '',
      // 当前选中的标签
      activeTab: "",
      // 加载状态
      loading: false,
      //保修详情id
      warrantyId: "",
      // 分页信息
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      // 保修列表数据
      warrantyList: [
      ],
      // 保修详情列表数据
      warrantyDetailList: [
      ],
      // 保修详情是否显示
      warrantyDetailVisible: false
    };
  },
  created() {
    // 初始化加载数据
    this.loadWarrantyList();
  },
  methods: {
    // 返回
    handleBack() {
      this.$router.go(-1);
    },
    // 搜索
    handleSearch() {
      this.loadWarrantyList();
    },
    // 标签切换
    handleTabClick(tab) {
      this.activeTab = tab.name;
      this.loadWarrantyList();
    },
    // 加载保修列表
    loadWarrantyList() {
      let params = {
        current: this.page.current,
        size: this.page.size,
        status: this.activeTab
      }
      warrantyPage(params).then(res => {
        this.warrantyList = res.data.data.records
        this.page.total = res.data.data.total
        this.page.current = res.data.data.current
        this.page.size = res.data.data.size
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error('加载失败')
      })                
    },
    // 查看历史
    handleViewHistory(item) {
      this.warrantyId = item.id
      this.getHistoryList(this.warrantyId)
    },
    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        '1': 'warning',
        '2': 'success',
        '3': 'danger'
      };
      return statusMap[status] || 'info';
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        '1': '待保修',
        '2': '已保养',
        '3': '已过期'
      };
      return statusMap[status] || '未知';
    },
    // 分页：每页条数改变
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.loadWarrantyList();
    },
    // 分页：当前页改变
    handleCurrentChange(val) {
      this.page.current = val;
      this.loadWarrantyList();
    },
    // 获取历史记录
    getHistoryList(id) {
      let params = {
        warrantyId: id
      }
      warrantyDetail(params).then(res => {
        this.warrantyDetailList = res.data.data
        this.warrantyDetailVisible = true
      }).catch(err => {
        this.$message.error('加载失败')
        this.warrantyDetailVisible = false
      })
    },
    // 关闭保修详情
    handleClose() {
      this.warrantyDetailVisible = false
      this.warrantyId = ""
      this.warrantyDetailList = []
    }
  }
};
</script>

<style lang="scss" scoped>
.warranty-container {
  padding: 0;
  background: #f5f7fa;
  min-height: calc(100vh - 100px);

  // 顶部搜索栏
  .header-bar {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    background: #fff;
    border-bottom: 1px solid #e4e7ed;

    .back-icon {
      font-size: 20px;
      color: #606266;
      cursor: pointer;
      margin-right: 15px;
      transition: color 0.3s;

      &:hover {
        color: #409eff;
      }
    }

    .search-input {
      flex: 1;
      max-width: 400px;
    }
  }

  // 标签容器
  .tabs-container {
    background: #fff;
    padding: 0 20px;
    border-bottom: 1px solid #e4e7ed;

    ::v-deep .el-tabs__header {
      margin: 0;
    }

    ::v-deep .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }
  .content-area {
    padding: 20px;
    min-height: calc(100vh - 200px);
    display: flex;
    justify-content: center;

    .table-card {
      background: #fff;
      width: 100%;
      max-width: 100%;

      ::v-deep .el-card__body {
        padding: 20px;
      }
      ::v-deep .el-table {
        width: 100%;
        .el-table__header-wrapper {
          th {
            background-color: #f5f7fa;
            color: #606266;
            font-weight: 500;
          }
        }
      }

      .pagination-container {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
}

// 历史记录对话框样式
::v-deep .history-dialog {
  .el-dialog {
    .el-dialog__header {
      background: #17a2b8;
      padding: 20px;
      .el-dialog__title {
        color: #fff;
        font-size: 18px;
        font-weight: 500;
      }
      .el-dialog__close {
        color: #fff;
        font-size: 20px;
        &:hover {
          color: #e0e0e0;
        }
      }
    }
    .el-dialog__body {
      padding: 30px;
      .el-table {
        .el-table__header-wrapper {
          th {
            background-color: #17a2b8;
            color: #fff;
            font-weight: 500;
            text-align: center;
          }
        }
        .el-table__body-wrapper {
          .el-table__row {
            td {
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
